/* tslint:disable */
/* eslint-disable */
export interface FileTextLineschema {
    lineNo: number;
    text: string;
}

export function instanceOfFileTextLineschema(value: object): boolean {
    return typeof value === 'object' && value != null && 'lineNo' in value && 'text' in value;
}

export function FileTextLineschemaFromJSON(json: any): FileTextLineschema {
    return FileTextLineschemaFromJSONTyped(json, false);
}

export function FileTextLineschemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): FileTextLineschema {
    if (json == null) {
        return json;
    }
    return {
        'lineNo': json['lineNo'],
        'text': json['text'],
    };
}

export function FileTextLineschemaToJSON(value?: FileTextLineschema | null): any {
    if (value == null) {
        return value;
    }
    return {
        'lineNo': value.lineNo,
        'text': value.text,
    };
}
